// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  email_icon,
  eye_icon,
  knf_logo,
  knfLogo,
  logo,
  password_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { isValidEmail } from "../redux/api/Constants";
import { useDispatch } from "react-redux";
import { useLoginMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Login = () => {
  const navigate = useNavigate();

  const [loginApi] = useLoginMutation();
  const [formState, setFormState] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [show, setShow] = useState(false);
  const [shake, setShake] = useState(false);

  const [passwords, setPassword] = useState();
  const [emailId, setEmailId] = useState();
  const [isPassFocused, setIsPassFocused] = useState(false);

  const { username, password } = formState;
  const { emailErr, passErr } = errors;

  const passwordRules = [
    {
      label: "At least 8 characters",
      test: (v) => v.length >= 8,
    },
    {
      label: "One uppercase letter",
      test: (v) => /[A-Z]/.test(v),
    },
    {
      label: "One lowercase letter",
      test: (v) => /[a-z]/.test(v),
    },
    {
      label: "One number",
      test: (v) => /[0-9]/.test(v),
    },
    {
      label: "One special character (!*@#%&()^~{})",
      test: (v) => /[!*@#%&()^~{}]/.test(v),
    },
  ];

  const validatePassword = (password) => {
    return password.length >= 4;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
    if (name === "username") {
      setErrors((prev) => ({
        ...prev,
        emailErr: !isValidEmail(value) ? "Please enter a valid Email" : "",
      }));
    }
    if (name === "password") {
      setErrors((prev) => ({
        ...prev,
        passErr: value?.length == 0 ? "Please enter a Password" : "",
      }));
    }
  };

  const handleKey = (event) => {
    if (event.key == "Enter" && formState.password && formState.username) {
      login();
    }
  };
  const login = () => {
    const emailValid = isValidEmail(username);
    const passwordValid = password?.length > 1;

    if (!emailValid || !passwordValid) {
      setShake(true);

      setTimeout(() => {
        setShake(false);
      }, 500);

      setErrors({
        emailErr: !emailValid ? "Please enter a valid Email" : "",
        passErr: !passwordValid ? "Please enter a Password" : "",
      });
      return;
    }
    // if (username.toLowerCase().includes("company")) {

    // } else {
    //   navigate("/admin-list");
    // }

    let fdata = new FormData();
    // fdata.append("email", btoa(username));
    // fdata.append("password", btoa(password));

    fdata.append("email", username);
    fdata.append("password", password);

    setLoader(true);
    loginApi(fdata)
      .unwrap()
      .then((res) => {
        // console.log(
        //   "Login Successful",
        //   res?.permissions,
        //   res?.role == "Company Manager",
        //   res?.company?.name
        // );
        if (res?.status == "success") {
          const {
            permissions = [],
            role,
            company,
            message = "Login successful",
            token,
            user,
            type,
          } = res ?? {};

          // ---------- Local storage ----------
          if (company) {
            localStorage.setItem("company", JSON.stringify(company));
          }
          let user_data = {
            ...user,
            login_type: type,
            login_type_role: role,
            login_knf_typ: res?.knf_role,
          };
          localStorage.setItem("token", token);
          localStorage.setItem("user_details", JSON.stringify(user_data));
          localStorage.setItem("type", type);
          localStorage.setItem("user_permission", JSON.stringify(permissions));
          localStorage.setItem("loginData", JSON.stringify(res));
          // ---------- Decide the target screen ----------
          let screen = "";

          // if (permissions.includes("CAN-List-ADMINS")) {
          //   screen = "/admin-list";
          // }
          // else if (permissions.includes("CAN-List-ROLES")) {
          //   screen = "/role";
          // } else if (permissions.includes("CAN-List-USERS")) {
          //   screen = "/user-list";
          // } else if (permissions.includes("CAN-List-DEVICES")) {
          //   screen = "/device-list";
          // } else if (permissions.includes("CAN-List-LOCATIONS")) {
          //   screen = "/location-marks";
          // }
          // if (type === "admin" && company?.name) {
          //   screen = "/admin-list";
          // }
          if (type === "admin") {
            screen = "/landing-page";
          } else if (type === "Company Manager" && company?.name) {
            // Eg. “acme-corp/manager”
            screen = `/${company.name}/manager`;
          } else if (type === "Company Sub Admin" && company?.name) {
            screen = `/${company.name}/manager`;
          } else if (type === "Company User" && company?.name) {
            screen = `/${company.name}/manager`;
          } else if (
            type === "Unknown" &&
            user?.knf_role?.id &&
            !user?.knf_type
          ) {
            screen = `/admin-dashboard`;
          } else if (type === "Unknown" && user?.knf_type == 1) {
            screen = `/company-Dashboard`;
          } else if (type === "Unknown" && user?.knf_type == 2) {
            screen = `/site-Dashboard`;
          } else if (
            type === "Unknown" &&
            user?.knf_type >= 3 &&
            user?.knf_type <= 5
          ) {
            screen = `/group-dashboard`;
          }

          // ---------- Act on the result ----------
          if (!screen) {
            toast.info("No List Permissions");
          } else {
            navigate(screen);
            toast.success(message);
          }

          // let permission = res?.permissions;
          // const company = localStorage.setItem("company", JSON.stringify(res?.company));

          // let screen = permission?.includes("CAN-List-ADMINS")
          //   ? "/admin-list"
          //   : permission?.includes("CAN-List-ROLES")
          //     ? "/role"
          //     : permission?.includes("CAN-List-USERS")
          //       ? "/user-list"
          //       : permission?.includes("CAN-List-DEVICES")
          //         ? "/device-list"
          //         : permission?.includes("CAN-List-LOCATIONS")
          //           ? "/location-marks" : res?.role == "Company Manager"
          //             ?
          //             navigate(res?.company?.name + "/manager")

          //             : "No List Permissions";

          // if (screen == "No List Permissions") {
          //   toast.info(screen);
          // } else {
          //   navigate(screen);
          // }
          // toast.success(res?.message);
          // localStorage.setItem("token", res?.token);
          // localStorage.setItem("user_details", JSON.stringify(res?.admin));
          // localStorage.setItem(
          //   "user_permission",
          //   JSON.stringify(res?.permissions)
          // );
        } else {
          toast.error(res?.message);
          // console.log("check");
        }
      })
      .catch((err) => {
        console.error("Login Failed", err);
        toast.error(err?.data?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    if (localStorage?.getItem("token")) {
      let company = JSON.parse(localStorage.getItem("company"));
      let user = JSON.parse(localStorage.getItem("user_details"));
      let type = localStorage.getItem("type");
      let screen = "";
      if (type === "admin") {
        screen = "/landing-page";
      } else if (type === "Company Manager" && company?.name) {
        // Eg. “acme-corp/manager”
        screen = `/${company.name}/manager`;
      } else if (type === "Company Sub Admin" && company?.name) {
        screen = `/${company.name}/manager`;
      } else if (type === "Company User" && company?.name) {
        screen = `/${company.name}/manager`;
      } else if (type === "Unknown" && user?.knf_role?.id && !user?.knf_type) {
        screen = `/admin-dashboard`;
      } else if (type === "Unknown" && user?.knf_type == 1) {
        screen = `/company-Dashboard`;
      } else if (type === "Unknown" && user?.knf_type == 2) {
        screen = `/site-Dashboard`;
      } else if (
        type === "Unknown" &&
        user?.knf_type >= 3 &&
        user?.knf_type <= 5
      ) {
        screen = `/group-dashboard`;
      }

      navigate(screen);
    }
  }, []);

  return (
    <div className="knf_login_page" onKeyDown={handleKey}>
      <div className="main-wrapper">
        {/* LEFT SIDE */}
        <div className="login-left">
          <img
            src={knfLogo} // your single image
            className="glass-image"
            alt="company"
          />
        </div>

        {/* RIGHT SIDE */}
        <div className="login-right">
          <div className="login-box">
            <h2 className="mt-4">Welcome Back!!</h2>

            <div className="text-start">
              <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                Email
              </p>
              <div className="login-input mt-2">
                <MailOutlineRoundedIcon className="emial-icon" />
                <input
                  type="email"
                  name="username"
                  placeholder="Email Address"
                  autoComplete="off"
                  value={username}
                  onChange={handleInputChange}
                />
              </div>
              {emailErr && (
                <p className="err" style={{ marginTop: "2%" }}>
                  {emailErr}
                </p>
              )}
            </div>

            <div className="text-start">
              <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                Password
              </p>
              <div className="login-input mt-2">
                <LockOutlinedIcon className="emial-icon" />
                <input
                  type={visible ? "text" : "password"}
                  name="password"
                  maxLength={20}
                  className="cust-btn ps-2 w-90"
                  placeholder="Password"
                  autoComplete="off"
                  value={password}
                  onChange={(e) => {
                    handleInputChange(e);
                    setIsPassFocused(true);
                  }}
                />
                {visible ? (
                  <VisibilityIcon
                    className="eye-icon pointer"
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <img
                    src={eye_icon}
                    className="eye-icon pointer"
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>
              {passErr && (
                <p className="err" style={{ marginTop: "2%" }}>
                  {passErr}
                </p>
              )}
              {isPassFocused && (
                <div className="login_pass">
                  <div className="password-rules">
                    {passwordRules.map((rule, index) => {
                      const passed = rule.test(password || "");
                      return (
                        <p
                          key={index}
                          className={`rule ${passed ? "success" : "error"}`}
                        >
                          {passed ? "✔" : "✖"} {rule.label}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="text-end mt-2">
              <p className="mt-1 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                <span
                  onClick={() => navigate("/registration")}
                  className="pointer"
                >
                  Forgot Password?
                </span>
              </p>
            </div>

            <button
              disabled={loader}
              onClick={() => login()}
              className={`login-btn-knf f2 ${shake ? "shake-btn" : ""}`}
            >
              {loader ? (
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                  style={{ marginRight: "5px" }}
                ></div>
              ) : (
                "Login"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
